<template>
    <div class="indicatorResult text-center" :class="{'float': float}">
        <div class="indicatorResult__icon">
                <img :src="'/themes/nutristopa/assets/img/' + indicator + '.png'"
                     v-if="showIcon"
                     v-tooltip.top="{ content: description}"
                >
        </div>
        <div class="indicatorResult__result">{{ result }}</div>
        <div class="indicatorResult__unit" v-html="unit + ' / porci'"></div>
    </div>
</template>

<script>
    import indicatorTexts from '../srores/IndicatorTexts';

    let units = {
        climate: 'g CO<sub>2</sub> eq.',
        acidification: 'g SO<sub>2</sub> eq.',
        euthropication: 'g P eq.',
        occupation: 'm<sup>2</sup> za rok',
        water: 'litrů',

        energy: 'kJ',
        fat: 'g',
        fattyacids: 'g',
        sugar: 'g',
        salt: 'g',
    };

    export default {

        data() {
            return {
                descriptions: indicatorTexts
            }
        },

        props: [
            'value',
            'indicator',
            'showIcon',
            'float'
        ],

        computed: {
            result() {
                return this.formatIndicatorValue(this.value, this.indicator);
            },

            unit () {
                return units[this.indicator];
            },

            description () {
                return this.descriptions[this.indicator];
            }
        },

        methods: {
            formatIndicatorValue(value, indicator) {

                switch(indicator){
                    case 'climate':
                        return Math.round(value * 1000 );
                        break;
                    case 'acidification':
                        return Math.round(value * 1000 );
                        break;
                    case 'euthropication':
                        return Math.round(value * 1000  * 1000) / 1000;
                        break;
                    case 'occupation':
                        return Math.round(value * 10 )  / 10;
                        break;
                    case 'water':
                        return Math.round(value * 1000 )  / 1000 * 1000;
                        break;

                    case 'energy':
                        return Math.round(value);
                        break;
                    case 'fat':
                        return Math.round(value * 10 ) / 10;
                        break;
                    case 'fattyacids':
                        return Math.round(value * 10) /10;
                        break;
                    case 'sugar':
                        return Math.round(value * 10) /10;
                        break;
                    case 'salt':
                        return Math.round(value * 10) /10;
                        break;
                }
            }
        }
    }
</script>

<style>
    .indicatorResult__icon {
        cursor: help;
    }
</style>